import { Link } from 'react-router-dom'
import Navbar from '@/components/layout/Navbar'
import Footer from '@/components/layout/Footer'
import PageHero from '@/components/layout/PageHero'
import { ArrowRight, Users } from 'lucide-react'

export default function About() {
  return (
    <div className="min-h-screen bg-white font-sans text-foreground selection:bg-accent selection:text-white">
      <Navbar light />
      <main className="relative">
        <PageHero
          label="About Us"
          title="The Lynas Story"
          intro="Lynas Rare Earths Limited is the world's only significant producer of separated rare earth materials outside China. Headquartered in Australia, we operate an integrated supply chain from Mt Weld to finished materials."
        />
        <div className="container max-w-3xl mx-auto px-6 pt-16 pb-24 md:pt-20 md:pb-32">
          <div className="prose prose-lg text-slate-600 max-w-none">
            <p className="text-lg leading-relaxed mb-6">
              Lynas is an Australian publicly listed company headquartered in Perth, Western Australia. We were established as an ethical and environmentally responsible producer for global manufacturing supply chains in East Asia, Europe and North America.
            </p>
            <p className="leading-relaxed mb-6">
              Lynas offers assured provenance from mine to finished rare earth materials through our integrated supply chain. This starts at our high-grade Mt Weld mine in Western Australia—one of the world&apos;s premier rare earth deposits—then processes at our facility in Kalgoorlie and the Lynas Malaysia advanced materials plant in Kuantan.
            </p>
            <p className="leading-relaxed mb-6">
              Rare earth materials are known as the &quot;vitamins&quot; of manufacturing due to their special magnetic, electrical, optical and catalytic properties. Lynas materials power high-tech applications including electronics, wind turbines and electric vehicles.
            </p>
            <p className="leading-relaxed mb-6">
              Lynas is listed on the Australian Securities Exchange (ASX: LYC). For investor enquiries, annual reports and corporate announcements, please visit our{' '}
              <Link to="/investors" className="text-accent font-semibold hover:underline">
                Investor Relations
              </Link>{' '}
              page.
            </p>
          </div>

          <Link
            to="/about/leadership"
            className="mt-12 inline-flex items-center gap-3 p-6 rounded-xl border border-slate-200 bg-slate-50/50 hover:border-accent/30 hover:bg-accent/5 transition-all duration-300 group"
          >
            <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-accent/10 text-accent group-hover:bg-accent/20 transition-colors">
              <Users className="h-6 w-6" />
            </div>
            <div>
              <h3 className="text-lg font-bold font-heading text-primary group-hover:text-accent transition-colors">
                Our Leadership Team
              </h3>
              <p className="text-slate-600 text-sm mt-0.5">
                Meet the executives driving Lynas&apos; mission to power a sustainable future.
              </p>
            </div>
            <ArrowRight className="h-5 w-5 text-slate-400 group-hover:text-accent group-hover:translate-x-1 transition-all ml-auto" />
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  )
}
